<template>
  <div class="page_agentManage">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="关键词" size="small">
              <el-input v-model="listQuery.keyword" placeholder="编码/名称/描述" size="small" clearable style="width:200px"></el-input>
            </el-form-item>
            <el-form-item label="状态" size="small">
              <el-select v-model="listQuery.status" placeholder="" clearable size="small" style="width:140px">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI 工作台</el-breadcrumb-item>
          <el-breadcrumb-item>Agent 管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addHandle">新增 Agent</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <el-table-column key="code" prop="code" label="Agent编码" min-width="150" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column key="name" prop="name" label="名称" min-width="150" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column key="desc" prop="description" label="描述" min-width="200" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column key="model" label="模型" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.modelProvider ? row.modelProvider + ' / ' + row.modelName : row.modelName }}</template>
          </el-table-column>
          <el-table-column key="status" prop="status" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <el-tag :type="statusTagType(row.status)" size="mini">{{ statusLabel(row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column key="isSystem" prop="isSystem" label="系统级" min-width="90" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.isSystem ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column key="action" label="操作" fixed="right" align="center" width="280">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editHandle(row)">编辑</el-button>
                <el-button type="text" size="small" @click="toolsHandle(row)">工具绑定</el-button>
                <el-button v-if="row.status != 1" type="text" size="small" @click="statusHandle(row, 1)">启用</el-button>
                <el-button v-if="row.status == 1" type="text" size="small" @click="statusHandle(row, 2)">禁用</el-button>
                <el-popconfirm title="请确认是否删除（仅草稿状态可删除）" @confirm="delHandle(row)" style="margin: 0 10px;">
                  <el-button type="text" slot="reference" size="small">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pagination.page" :page-size="Number(listQuery.pagination.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增/编辑 -->
    <el-dialog :title="dialogType == 'add' ? '新增 Agent' : '编辑 Agent'" :visible.sync="dialogVisible" width="780px" class="res_dialog" :close-on-click-modal="false">
      <el-form ref="agentForm" :model="agentForm" :rules="rules" label-width="110px" size="small">
        <el-form-item label="Agent编码" prop="code">
          <el-input v-model="agentForm.code" placeholder="租户范围内唯一" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="agentForm.name" placeholder="请输入名称" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="agentForm.description" placeholder="Agent用途说明" style="width:500px"></el-input>
        </el-form-item>
        <el-form-item label="模型供应商" prop="modelProvider">
          <el-select v-model="agentForm.modelProvider" filterable clearable placeholder="请选择" style="width:240px">
            <el-option v-for="item in providerOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模型名称" prop="modelName">
          <el-input v-model="agentForm.modelName" placeholder="请输入模型名称" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="模型参数配置" prop="modelConfig">
          <el-input v-model="agentForm.modelConfig" type="textarea" :rows="3" placeholder='JSON对象，如 {"temperature":0.7,"maxTokens":2048}' style="width:500px"></el-input>
        </el-form-item>
        <el-form-item label="系统提示词" prop="systemPrompt">
          <el-input v-model="agentForm.systemPrompt" type="textarea" :rows="6" placeholder="请输入Agent系统提示词" style="width:560px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSave" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 工具绑定 -->
    <el-dialog title="工具绑定" :visible.sync="toolsVisible" width="780px" class="res_dialog" :close-on-click-modal="false">
      <div style="margin-bottom:10px;color:#909399;font-size:13px">Agent：{{ currentAgent && currentAgent.name }}（{{ currentAgent && currentAgent.code }}）</div>
      <el-table :data="toolBindings" border size="small" style="width:100%">
        <el-table-column key="enabled" label="启用" width="70" align="center">
          <template slot-scope="{row}">
            <el-checkbox v-model="row.enabled"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column key="toolId" label="工具" min-width="160" align="center">
          <template slot-scope="{row}">
            <el-select v-model="row.toolId" size="mini" filterable placeholder="选择工具" style="width:140px" @change="changeBindingTool(row)">
              <el-option v-for="t in availableTools" :key="t.tool.id" :label="t.tool.name" :value="t.tool.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column key="toolVersionId" label="版本" min-width="180" align="center">
          <template slot-scope="{row}">
            <el-select v-model="row.toolVersionId" size="mini" filterable placeholder="选择版本" style="width:160px">
              <el-option v-for="v in versionsFor(row.toolId)" :key="v.id" :label="v.version + ' · ' + v.functionName" :value="v.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column key="sort" label="排序" width="100" align="center">
          <template slot-scope="{row}">
            <el-input-number v-model="row.sort" :min="0" :controls="false" size="mini" style="width:80px"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column key="configOverride" label="配置覆盖(JSON)" min-width="200" align="center">
          <template slot-scope="{row}">
            <el-input v-model="row.configOverride" type="textarea" :rows="2" size="mini" placeholder="{}"></el-input>
          </template>
        </el-table-column>
        <el-table-column key="toolAction" label="操作" width="70" align="center">
          <template slot-scope="$scope">
            <el-button type="text" size="mini" @click="toolBindings.splice($scope.$index, 1)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:10px">
        <el-button type="text" size="small" @click="addToolRow">+ 增加工具</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toolsVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmBindTools" :loading="isToolLoading" size="small">保存绑定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission'
  export default {
    data() {
      return {
        listQuery: {
          keyword: '',
          status: null,
          pagination: {
            page: 1,
            pageSize: 10
          }
        },
        statusOptions: [
          { label: '草稿', value: 0 },
          { label: '启用', value: 1 },
          { label: '禁用', value: 2 }
        ],
        providerOptions: ['deepseek'],
        tableData: [],
        totalCount: 0,
        loading: false,
        dialogVisible: false,
        dialogType: 'add',
        isBtnLoading: false,
        agentForm: this.blankForm(),
        rules: {
          code: [{ required: true, message: '请输入Agent编码', trigger: 'blur' }],
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          systemPrompt: [{ required: true, message: '请输入系统提示词', trigger: 'blur' }],
          modelProvider: [{ required: true, message: '请选择模型供应商', trigger: 'change' }],
          modelName: [{ required: true, message: '请输入模型名称', trigger: 'blur' }]
        },
        toolsVisible: false,
        isToolLoading: false,
        currentAgent: null,
        toolBindings: [],
        availableTools: []
      }
    },
    created() {
      this.getList();
    },
    methods: {
      checkPermission,
      blankForm() {
        return {
          id: 0,
          tenantId: 0,
          code: '',
          name: '',
          description: '',
          systemPrompt: '你是一个专业的AI助手。',
          modelProvider: 'deepseek',
          modelName: '',
          modelConfig: '{\n  "temperature": 0.2\n}',
          isSystem: false,
          operatorUserId: null
        }
      },
      statusLabel(val) {
        let item = this.statusOptions.find(x => x.value === val);
        return item ? item.label : '-';
      },
      statusTagType(val) {
        if (val === 1) return 'success';
        if (val === 2) return 'danger';
        return 'info';
      },
      currentChange(val) {
        this.listQuery.pagination.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.pagination.page = 1;
        this.listQuery.pagination.pageSize = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pagination.page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.getAgentPage(this.listQuery).then(res => {
          if (res) {
            this.tableData = res.data.data || [];
            this.totalCount = res.totalCount || 0;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
          this.loading = false;
        }).catch(() => {
          this.tableData = [];
          this.totalCount = 0;
          this.loading = false;
        });
      },
      addHandle() {
        this.dialogType = 'add';
        this.agentForm = this.blankForm();
        this.isBtnLoading = false;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.agentForm && this.$refs.agentForm.clearValidate();
        });
      },
      editHandle(row) {
        this.dialogType = 'edit';
        this.isBtnLoading = false;
        xz.getAgentDetail(row.id).then(res => {
          if (res && res.agent) {
            this.agentForm = Object.assign(this.blankForm(), res.agent);
            this.dialogVisible = true;
            this.$nextTick(() => {
              this.$refs.agentForm && this.$refs.agentForm.clearValidate();
            });
          } else {
            this.$message.error('获取详情失败');
          }
        });
      },
      confirmSave() {
        this.$refs.agentForm.validate(valid => {
          if (!valid) return;
          this.isBtnLoading = true;
          let payload = Object.assign({}, this.agentForm);
          payload.id = Number(payload.id);
          payload.tenantId = Number(payload.tenantId);
          payload.operatorUserId = Number(Cookies.get("userid-b")) || null;
          let req = this.dialogType === 'add'
            ? xz.createAgent(payload)
            : xz.updateAgent(payload);
          req.then(res => {
            this.isBtnLoading = false;
            if (res !== false) {
              this.$message.success(this.dialogType === 'add' ? 'Agent已创建' : 'Agent已保存');
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message.error('保存失败');
            }
          }).catch(() => {
            this.isBtnLoading = false;
          });
        });
      },
      statusHandle(row, status) {
        xz.updateAgentStatus(row.id, status).then(res => {
          if (res !== false) {
            this.$message.success(status === 1 ? 'Agent已启用' : 'Agent已禁用');
            this.getList();
          } else {
            this.$message.error('操作失败');
          }
        });
      },
      delHandle(row) {
        xz.deleteAgent(row.id).then(res => {
          if (res !== false) {
            this.$message.success('删除成功');
            this.getList();
          } else {
            this.$message.error('删除失败');
          }
        });
      },
      toolsHandle(row) {
        this.currentAgent = row;
        this.toolBindings = [];
        this.availableTools = [];
        Promise.all([
          xz.getAgentDetail(row.id),
          xz.getToolPage({ pagination: { page: 1, pageSize: 200 }, keyword: null, status: null })
        ]).then(([agentRes, toolsRes]) => {
          let toolRows = (toolsRes && toolsRes.data) || [];
          Promise.all(toolRows.map(t => xz.getToolDetail(t.id))).then(details => {
            this.availableTools = details.filter(d => d);
            this.toolBindings = ((agentRes && agentRes.tools) || []).map(t => ({
              toolId: t.toolId,
              toolVersionId: t.toolVersionId,
              enabled: t.enabled !== false,
              sort: t.sort || 0,
              configOverride: t.configOverride || '{}'
            }));
            this.toolsVisible = true;
          });
        });
      },
      versionsFor(toolId) {
        let tool = this.availableTools.find(t => t.tool && t.tool.id === Number(toolId));
        return tool ? tool.versions : [];
      },
      changeBindingTool(binding) {
        let versions = this.versionsFor(binding.toolId);
        binding.toolVersionId = versions.length ? versions[0].id : 0;
      },
      addToolRow() {
        let first = this.availableTools.find(t => t.versions && t.versions.length);
        if (!first) {
          this.$message.warning('请先创建至少一个工具版本');
          return;
        }
        this.toolBindings.push({
          toolId: first.tool.id,
          toolVersionId: first.versions[0].id,
          enabled: true,
          sort: this.toolBindings.length,
          configOverride: '{}'
        });
      },
      confirmBindTools() {
        this.isToolLoading = true;
        let payload = this.toolBindings.map(item => ({
          toolId: Number(item.toolId),
          toolVersionId: Number(item.toolVersionId),
          enabled: item.enabled,
          sort: Number(item.sort),
          configOverride: item.configOverride
        }));
        xz.bindAgentTools(this.currentAgent.id, payload).then(res => {
          this.isToolLoading = false;
          if (res !== false) {
            this.$message.success('工具绑定已保存');
            this.toolsVisible = false;
          } else {
            this.$message.error('保存失败');
          }
        }).catch(() => {
          this.isToolLoading = false;
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }
</style>
<style>
  .page_agentManage .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_agentManage .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_agentManage .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_agentManage .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>
